export default function PHP_ob_start() {
  return (
    <div>
      <h1>PHP_ob_start</h1>
    </div>
  );
}
